import { useContext } from "react";
import { ConfigProviderContext } from "../contexts/ConfigProviderContext";
/**
 * Gets the config provider from the React context
 * @throws {Error} Thrown if the value is undefined.
 */ export const useConfigProvider = ()=>{
    const configProvider = useContext(ConfigProviderContext);
    if (!configProvider) {
        throw new Error("useConfigProvider must be used within a ConfigProviderContext");
    }
    return configProvider;
};
